import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const AaaDashboardPage = loadable(() =>
  withDefaultLoaderModifiers(import("./AaaDashboardPage"))
);
